export const baseURL = "https://yoga-play-api.suyashpradhan.repl.co";

export const videos = `${baseURL}/videos`;
export const singleVideo = `${baseURL}/:id`;
export const register = `${baseURL}/register`;
export const login = `${baseURL}/login`;
export const favourites = `${baseURL}/favourites`;
export const history = `${baseURL}/history`;
export const watchLaterURL = `${baseURL}/watch-later`;
export const notesURL = `${baseURL}/add-note`;
